/**
 * Bootstrap verses TAGGED with Strong numbers (OFFLINE concordance).
 *
 * Base KJV text lives in `kjv-seed.ts`. Here we replace text for a
 * subset of verses with the SAME KJV string but inserting Strong markup
 * immediately after corresponding word, using standard syntax.
 * que entiende `@/utils/verse-text` (`formatVerseText`):
 *   - `<WH####>` para hebreo (Antiguo Testamento)
 *   - `<WG####>` para griego (Nuevo Testamento)
 *
 * When Strong numbers are hidden, `formatVerseText` strips markup and
 * text renders identical to KJV; when visible, each tagged word
 * becomes interactive and opens lexicon entry (see `strong-lexicon.ts`).
 *
 * Key is `book-chapter-verse` coordinate (same ids as `kjv-seed.ts`:
 * Genesis = 1, John = 43).
 *
 * NOTE: tagging a verse splits rendered text into spans (word
 * + Strong number), so it no longer matches as a single string. We therefore
 * do NOT tag verses asserted by `reader.spec.ts` full text checks
 * (Genesis 1:1, Genesis 2:1, John 3:16): neighboring verses are chosen
 * (Genesis 1:3 -> Hebrew, John 1:1 -> Greek) covering OT and NT safely.
 *
 * This module is DATA (biblical text + public domain markup), not UI strings.
 */

/** Mapa coordenada (`book-chapter-verse`) → texto KJV con marcas Strong. */
export const STRONG_TAGGED_VERSES: Record<string, string> = {
  // Genesis 1:3 — Old Testament (Hebrew).
  "1-1-3": "And God<WH430> said<WH559>, Let there be light<WH216>: and there was light<WH216>.",
  // Juan 1:1 — apertura del Nuevo Testamento (griego).
  "43-1-1":
    "In the beginning<WG746> was the Word<WG3056>, and the Word<WG3056> was with God<WG2316>, and the Word<WG3056> was God<WG2316>.",
};
